import get from 'lodash/get';
import find from 'lodash/find';
import filter from 'lodash/filter';

import A from './types';
import {makePlaceObject} from '~/misc/geocoding';

const initialState = {};

const placeValue = (freshResult) => {
  let location;

  if (freshResult.selectedResult) {
    location = freshResult.selectedPlaceDetails || {name: freshResult.selectedResult.description};
  } else {
    location = {name: freshResult.criteria};
  }
  return {...freshResult, placeValue: makePlaceObject(location)};
};

const chunk = (value, isMatched) => value ? {value, isMatched} : null;

const getNonMatchedStart = (relatedMatch, item) => {
  const end = relatedMatch.offset - item.offset;
  return relatedMatch.offset > item.offset && item.value.slice(0, end);
};

const getNonMatchedEnd = (relatedMatch, item) => {
  const matchedEndPos = relatedMatch.offset + relatedMatch.length;
  const valueEndPos = item.offset + item.value.length;
  if (matchedEndPos >= valueEndPos) {
    return false;
  }
  return item.value.slice(matchedEndPos - item.offset);
};

const itself = (item) => item;

const searchResult = (action) => {
  if (action.error) {
    return {error: action.error};
  }

  if (action.pending) {
    return {pending: true};
  }
  const list = action.payload || [];
  const result = list && list.map((place) => {
    const nameParts = place.terms.map((item) => {
      const relatedMatch = find(place.matched_substrings, (match) => {
        if (match.offset >= item.offset
          && ((match.offset + match.length) <= (item.offset + item.value.length))) {
          return true;
        }
        return false;
      });

      if (!relatedMatch) {
        return [chunk(item.value, false)];
      }

      const start = chunk(getNonMatchedStart(relatedMatch, item), false);

      const middleStart = relatedMatch.offset - item.offset;
      const middle = chunk(item.value.slice(
        middleStart,
        middleStart + relatedMatch.length),
      true
      );

      const end = chunk(getNonMatchedEnd(relatedMatch, item), false);
      return filter([start, middle, end], itself);
    });

    return {
      ...place,
      nameParts: {
        main: nameParts[0],
        rest: nameParts.slice(1),
      },
    };
  });
  return {list: result};
};

const searchResult2 = (action) => {
  if (action.error) {
    return {error: action.error};
  }

  const ct = action.payload || {};
  const list = ct.content || [];
  const input = ct.input || '';

  const result = list.map(x => {
    const ds = x.title.split(',');
    const rgx = new RegExp(`(.*?)(${input})(.*)`, 'i');
    const mainPart = x.title.match(rgx) || [];
    const nameParts = {
      main: [],
      rest: [],
    };

    if (!mainPart.length || mainPart.length !== 4) {
      return null;
    }

    if (mainPart[1]) {
      nameParts.main.push({
        value: mainPart[1],
        isMatched: false,
      });
    }
    nameParts.main.push({
      value: mainPart[2],
      isMatched: true,
    });
    if (mainPart[3]) {
      nameParts.main.push({
        value: mainPart[3],
        isMatched: false,
      });
    }
    ds.slice(1).forEach(item => {
      nameParts.rest.push([{
        value: item.trim(),
        isMatched: false,
      }]);
    });
    return {
      id: x.placeId,
      place_id: x.placeId,
      nameParts: nameParts,
    };
  });

  return {list: result.filter(item => item !== null)};
};

const reducer = (state, action, fullState) => {
  switch (action.type) {
    case A.GEOSEARCH_CRITERIA: {
      const id = action.payload.id;
      const target = state[id] || {};
      return {[id]: placeValue({
        from_state_name: target.from_state_name,
        hasFocus: target.hasFocus,
        criteria: action.payload.criteria,
      })};
    }
    case A.GEOSEARCH_RESULTS: {
      const id = action.meta.id;
      const country = action.meta.country;

      const target = state[id] || {};
      const searchState = target.search;
      return {
        [id]: placeValue({
          hasFocus: target.hasFocus,
          search: {
            ...searchState,
            [country]: searchResult2(action),
          },
          criteria: target.criteria,
          from_state_name: target.from_state_name
        }),
      };
    }
    case A.GEOSEARCH_SELECTED_PLACE: {
      const id = action.payload.id;
      const target = state[id] || {};

      return {[id]: placeValue({...target, selectedResult: action.payload.place})};
    }
    case A.GEOSEARCH_READY_PLACE: {
      if (action.pending || action.error) {
        return null;
      }

      const id = action.meta.id;
      const placeId = action.meta.place_id;
      const target = state[id] || {};

      if (get(target, 'selectedResult.place_id') !== placeId) {
        return null;
      }
      const place = fullState.places[placeId].data;

      return {[id]: placeValue({...target, selectedPlaceDetails: place})};
    }
    case A.DELECT_GEOSEARCH_OPTION: {
      const id = action.payload.id;
      const key = action.payload.key;
      const target = state[id] || {};
      target.selected.splice(key, 1);
      return {[id]: {...target, selected: target.selected}};
    }
    case A.CHANGE_GEOSEARCH_SELECTED: {
      const id = action.payload.id;
      const target = state[id] || {};
      return {[id]: {...target, selected: action.payload.selected}};
    }


    case A.CREATE_OPTION: {
      const id = action.payload.id;
      const target = state[id] || {};
      const selected = target.selected || [];
      selected.push({
        isShow: false,
        isSelect: false,
        placeValue: {},
        selectedResult: {},
        selectedPlaceDetails: {}
      })
      return {[id]: {...target, selected}};
    }

    case A.MULTIPLE_GEOSEARCH_RESULTS: {
      const id = action.meta.id;
      const country = action.meta.country;

      const target = state[id] || {};
      const searchState = target.search;

      return {
        [id]: {
          ...target,
          search: {
            ...searchState,
            [country]: searchResult2(action),
          }
        },
      };
    }

    case A.MULTIPLE_SET_KEY: {
      const id = action.payload.id;
      const key = action.payload.key;
      const target = state[id] || {};

      return {[id]: {...target, key}};
    }

    case A.MULTIPLE_SET_TEMPORARY_DATA: {
      const id = action.payload.id;
      const key = action.payload.key;
      const target = state[id] || {};

      return {[id]: {...target, temporaryData: target.selected[key]}};
    }

    case A.MULTIPLE_SET_ISSHOW: {
      const id = action.payload.id;
      const key = action.payload.key;
      const bol = action.payload.bol;
      const target = state[id] || {};
      const selected = target.selected
      selected[key].isShow = bol
      return {[id]: {...target, selected}};
    }

    case A.MULTIPLE_SELECTED: {
      const id = action.payload.id;
      const placeId = action.payload.place_id;
      const selectedResult = action.payload.selectedResult;
      const selectedPlaceDetails = fullState.places[placeId].data;
      const target = state[id] || {};

      const location = selectedPlaceDetails || {name: selectedResult.description};
      target.selected[target.key] = {
        isShow: false,
        isSelect: true,
        placeValue: makePlaceObject(location),
        selectedResult,
        selectedPlaceDetails
      };
      return {[id]: {...target}};
    }

    case A.MULTIPLE_GEOSEARCH_CRITERIA: {
      const id = action.payload.id;
      const criteria = action.payload.criteria;
      const target = state[id] || {};
      if (criteria !== target.selected[target.key].placeValue.name) {
        target.selected[target.key] = {
          isShow: true,
          isSelect: target.selected[target.key].isSelect,
          placeValue: makePlaceObject({name: criteria}),
        };
      }
      return {[id]: {
        ...target,
        criteria,
      }};
    }

    case A.MULTIPLE_CHECK_SELECT_INPUT: {
      const id = action.payload.id;
      const key = action.payload.key;
      const target = state[id] || {};
      target.selected[key] = {
        ...target.selected[key],
        placeValue: target.temporaryData.placeValue,
        selectedResult: target.temporaryData.selectedResult,
        selectedPlaceDetails: target.temporaryData.selectedPlaceDetails
      }
      return {[id]: {...target}};
    }

    case A.MULTIPLE_INIT_SELECT: {
      const id = action.payload.id;
      const data = action.payload.data;
      return {[id]: data};
    }

    case A.MULTIPLE_CLEAR: {
      Reflect.deleteProperty(state, 'alert:destination-field');
      Reflect.deleteProperty(state, 'alert:origin-field');
      return {...state};
    }




    case A.GEOSEARCH_BLUR:
    case A.GEOSEARCH_FOCUS: {
      const id = action.payload.id;
      const target = state[id] || {};

      return {
        [id]: {
          ...target,
          hasFocus: (action.type === A.GEOSEARCH_FOCUS),
        },
      };
    }

    case A.GEOSEARCH_DELETE_LIST: {
      const id = action.payload.id;
      if (!state[id]) {
        return null;
      }
      const list = state;
      delete list[id];
      return {
        [id]: {},
      };
    }
    case A.GEOSEARCH_SAVE_VALUE: {
      const id = action.payload.id;
      const target = state[id] || {};
      const result = {[id]: { ...target, from_state_name: action.payload.state }}
      console.log('GEOSEARCH_SAVE_VALUE',result);
      return {[id]: { ...target, from_state_name: action.payload.state }};
    }
  }

  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/geosearch/reducer.js